export default __webpack_public_path__ + "media/Search.873b9b78.svg";